angular
    .module('app')
    .component('games', {
        templateUrl: '/templates/pages/games/games.html',
        controller: 'GamesController',
        controllerAs: 'vm',
    });